import { FC } from "react";
import DialogConfirmation from "../../../../TrueUI/Dialogs/DialogConfirmation";
type DialogInsuredOfficerValidationProps = {
  showDialog: boolean;
  closeDialog: (showDialog: boolean) => void;
  continueWithClaim: () => void;
};
const DialogInsuredOfficerValidation: FC<
  DialogInsuredOfficerValidationProps
> = ({ showDialog, closeDialog, continueWithClaim }) => {
  return (
    <DialogConfirmation
      name="insured-incident-dialog"
      id="insuredIncidentDialog"
      open={showDialog}
      dialogDescriptionText={
        "The claimant entered looks like it may be an excluded officer on the policy.  Do you want to continue?"
      }
      onCloseEvent={(close) => closeDialog(close)}
      onOptionNoEvent={(close) => closeDialog(close)}
      onOptionYesEvent={() => continueWithClaim()}
    />
  );
};
export default DialogInsuredOfficerValidation;
